import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../Store';
import { getUserInfo } from '../utils';

export default function AdminRoute({ children }) {
	useContext(Store);
	const userInfo = getUserInfo();
	const isAdmin = userInfo && (userInfo.role === 'admin' || userInfo.role === 'super_admin');
	return isAdmin ? children : <Navigate to='/AdminScreen' />;
}
